<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">动态互动管理</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>类型：</label>
          <el-select v-model="type" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>审核状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="发表时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <div style="display: flex; align-items: center;">
            <label>评论序号：</label>
            <el-input type="search" placeholder="请输入评论序号" :disabled="dynamicIdChecked" v-model="dynamicId" style="width: 12em;">
              <template #prefix>
                <el-icon class="el-input__icon"><ElIcons name="search" /></el-icon>
              </template>
            </el-input>
            <el-checkbox v-model="dynamicIdChecked" style="margin-left: 8px;" @change="noId()">不限序号</el-checkbox>
          </div>
        </div>
        <div class="content-input-item">
          <div style="display: flex; align-items: center;">
            <label>动态序号：</label>
            <el-input type="search" placeholder="请输入动态序号" :disabled="zoneIdChecked" v-model="zoneId" style="width: 12em;">
              <template #prefix>
                <el-icon class="el-input__icon"><ElIcons name="search" /></el-icon>
              </template>
            </el-input>
            <el-checkbox v-model="zoneIdChecked" style="margin-left: 8px;" @change="noZoneId()">不限序号</el-checkbox>
          </div>
        </div>
        <div class="content-input-item">
          <label>举报状态：</label>
          <el-select v-model="reportState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in reportStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>隐藏状态：</label>
          <el-select v-model="showState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in showStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="举报时间：" @date="getReportTime($event)" @check="getReportCheck($event)" :isChecked="isReportChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType" :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" width="9em"/>
          <el-checkbox v-model="limitState" style="margin-left: 8px;">有限制</el-checkbox>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" v-loading="searchLoading"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="batchUpdate(1, 0)" v-loading="batchLoading">批量通过-展示</el-button>
          <el-button type="warning" @click="batchUpdate(1, 1)" v-loading="batchLoading">批量通过-隐藏</el-button>
          <el-button type="danger"  @click="batchRejectUpdate()" v-loading="batchLoading">批量不通过</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            border
            @sort-change="sortChange"
        >
          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>
          <el-table-column property="createTime" label="发表时间" v-if="checkColList.indexOf('发表时间') > -1" width="106" sortable='custom'/>
          <el-table-column property="reportUserUid" label="举报状态" v-if="checkColList.indexOf('举报状态') > -1" width="106" sortable='custom'>
            <template #default="scope">
              <p>{{scope.row.reportCreateTime}}</p>
              <p v-if="scope.row.reportUserUid">被{{scope.row.reportUserUid}}举报</p>
            </template>
          </el-table-column>
          <el-table-column property="msg" label="内容" v-if="checkColList.indexOf('内容') > -1" width="120"/>
          <el-table-column property="" label="类型/序号" v-if="checkColList.indexOf('类型/序号') > -1" width="160">
            <template #default="scope">
              <p>类型：{{scope.row.type == 2?'评论':scope.row.type == 3?'回复':''}}</p>
              <p>评论序号：<span v-if="scope.row.type == 3">{{ scope.row.preId }}</span><span v-else>{{ scope.row.id }}</span></p>
              <p>动态序号：{{scope.row.zoneId}}</p>
            </template>
          </el-table-column>
<!--          <el-table-column property="" label="评论序号" v-if="checkColList.indexOf('评论序号') > -1" width="90">-->
<!--            <template #default="scope">-->
<!--              <p v-if="scope.row.type == 3">{{ scope.row.preId }}</p>-->
<!--              <p v-else>{{ scope.row.id }}</p>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column property="zoneId" label="动态序号" v-if="checkColList.indexOf('动态序号') > -1" width="90"/>-->
          <el-table-column label="发表人" v-if="checkColList.indexOf('发表人') > -1" width="200">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid"/>
            </template>
          </el-table-column>
          <el-table-column label="发表人头像"  v-if="checkColList.indexOf('发表人头像') > -1" width="110">
            <template #default="scope">
              <el-image
                  style="width: 80px; height: 80px"
                  :src="scope.row.headImg.smallHeadImg"
                  @click="showImg(scope.row.headImg.headImg)"
                  class="cursor"
              >
              <template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column label="发表人日志" v-if="checkColList.indexOf('发表人日志') > -1" class-name="cursor" width="170">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
          <el-table-column prop="" label="评论作者" width="190" v-if="checkColList.indexOf('评论作者') > -1">
            <template #default="scope">
              <div v-if="scope.row.toResumeInfo"><UserInfoList :row="scope.row.toResumeInfo" showList="name,uid,phone"/></div>
            </template>
          </el-table-column>
          <el-table-column label="动态作者" v-if="checkColList.indexOf('动态作者') > -1" width="200">
            <template #default="scope">
              <UserInfoList :row="scope.row.zoneAuthorResumeInfo" showList="name,phone,uid"/>
            </template>
          </el-table-column>
          <el-table-column label="作者头像" v-if="checkColList.indexOf('作者头像') > -1" width="110">
            <template #default="scope">
              <el-image
                  style="width: 80px; height: 80px"
                  :src="scope.row.zoneAuthorResumeInfo.headImg.smallHeadImg"
                  @click="showImg(scope.row.zoneAuthorResumeInfo.headImg.headImg)"
                  class="cursor"
              >
              <template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column label="作者日志" v-if="checkColList.indexOf('作者日志') > -1" class-name="cursor" width="170">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.zoneAuthorResumeInfo.userLogList" />
            </template>
          </el-table-column>
<!--          <el-table-column label="机审状态" v-if="checkColList.indexOf('机审状态') > -1" width="84">-->
<!--            <template #default="scope">-->
<!--              <p>{{scope.row.machineAuditState==0?'待审核':scope.row.machineAuditState==1?'已通过':scope.row.machineAuditState==2?'未通过':'&#45;&#45;'}}</p>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column label="人审状态" v-if="checkColList.indexOf('人审状态') > -1" width="120">-->
<!--            <template #default="scope">-->
<!--              <p>{{scope.row.state==0?'待审核':scope.row.state==1?'审核通过':scope.row.state==2?'审核不通过':'&#45;&#45;'}}</p>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column label="审核状态" v-if="checkColList.indexOf('审核状态') > -1" width="120" fixed="right">
            <template #default="scope">
              <p>{{scope.row.state==0?'待审核':scope.row.state==1?'审核通过':scope.row.state==2?'审核不通过':'--'}}</p>
              <p>{{scope.row.showState==0?'展示中':scope.row.showState==1?'隐藏-通过':scope.row.showState==2?'隐藏-不通过':scope.row.showState==3?'隐藏-被举报':scope.row.showState==4?'隐藏-封号':scope.row.showState==5?'隐藏-屏蔽':scope.row.showState==6?'隐藏-黑名单':scope.row.showState==7?'隐藏中':''}}</p>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
// import BtnGroup from '../../components/BtnGroup'
import ImgViewer from '../../assets/js/imageViewer'
import {
  getZoneInteractPageList, updateZoneInteractState
} from '../../api/url'
import { getFormData, deleteFormData, postFormData } from '../../api/api'
import Dialog from "@/assets/js/dialog";
import UserLogDialog from "@/components/UserLog/UserLogDialog";
import VideoPlay from "@/components/VideoPlay";
import {common} from "@/assets/shared/select-constant";
import UserLog from "@/components/UserLog/UserLog";
import BatchPassDialog from "@/views/dynamic/components/BatchPassDialog";
import BatchRejectDialog from "@/views/dynamic/components/BatchRejectDialog";

export default {
  name: "DynamicInteract",
  components: { DatePickerRange, SearchComponents, UserLog },
  data() {
    return {

      typeArray: [
        {label: '不限', value: -1},
        {label: '评论', value: 2},
        {label: '回复', value: 3},
      ],
      type: 2,

      // machineAuditStateArray: [
      //   { label: "不限" ,value : -1 },
      //   { label: "待审核", value : 0 },
      //   { label: "已通过", value : 1 },
      //   { label: "未通过", value : 2 },
      // ],
      // machineAuditState: 0,

      stateArray: [
        { label: "不限" ,value : -1 },
        { label: "待审核", value : 0 },
        { label: "已通过", value : 1 },
        { label: "不通过", value : 2 },
      ],
      state: -1,

      showStateArray: [
        { label: "不限" ,value : -1 },
        { label: "展示中", value : 0 },
        { label: "隐藏中", value : 7 },
        { label: "隐藏-通过", value : 1 },
        { label: "隐藏-不通过", value : 2 },
        { label: "隐藏-被举报", value : 3 },
        { label: "隐藏-封号", value : 4 },
        { label: "隐藏-屏蔽", value : 5} ,
        { label: "隐藏-黑名单", value : 6 },
      ],
      showState: -1,

      reportStateArray: [
        { label: "不限" ,value : -1 },
        { label: "未被举报", value : 0 },
        { label: "已被举报", value : 1 },
      ],
      reportState: -1,

      // abduceStateArray: [
      //   {label: '不限', value: -1},
      //   {label: '展示', value: 0},
      //   {label: '不展示', value: 1},
      // ],
      // abduceState: -1,

      sexArray: [
        {label: '不限', value: -1},
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: -1,

      // //删除
      // isDelArray: [
      //   {label: '不限', value: -1},
      //   {label: '正常', value: 0},
      //   {label: '评论本人删除', value: 1},
      //   {label: '动态作者删除', value: 2},
      // ],
      // isDel: -1,

      //评论序号
      dynamicId: '',
      dynamicIdChecked: true,

      //动态序号
      zoneId: '',
      zoneIdChecked: true,

      //时间
      startTime: '',
      endTime: '',
      isChecked: false,

      //举报时间
      reportStartTime: '',
      reportEndTime: '',
      isReportChecked: true,


      //搜索
      searchTypeList: [
        {label : '发起人手机号', value : 1},
        {label : '发起人昵称', value : 2},
        {label : '互动内容', value : 3},
        {label : '发表人UID', value : 4},
      ],
      searchType: 1,
      searchValue: '',


      //刷新组
      colList: ['发表时间', '举报状态', '内容', '类型/序号', '发表人', '发表人头像', '发表人日志', '评论作者', '动态作者', '作者头像',  '作者日志', '审核状态'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      listLoading: false,
      searchLoading: false,
      bitchPassLoading: false,
      bitchHideLoading: false,
      bitchForbidLoading: false,


      idArray: [],
      userIdArr: [],
      batchLoading: false,

      sort: 1,

      limitState: false,

    }
  },
  methods: {

    noId() {
      if(this.dynamicIdChecked) {
        this.dynamicId = ''
      }
    },

    noZoneId() {
      if(this.zoneIdChecked) {
        this.zoneId = ''
      }
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },

    getReportTime(val) {
      this.reportStartTime = val[0];
      this.reportEndTime = val[1];
      // console.log(val)
    },

    getReportCheck(val) {
      this.isReportChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = false;
      this.isReportChecked = true;
      this.dynamicIdChecked = true;
      this.zoneIdChecked = true;
      this.state = -1;
      // this.abduceState = -1;
      this.type = 2;
      this.machineAuditState = 0;
      this.sex = -1;
      this.reportState = -1;
      this.showState = -1;
      // this.isDel = -1;
      this.searchValue = '';
      this.dynamicId = '';
      this.zoneId = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },


    //排序
    sortChange(column) {
      this.sort = 1;
      if(column.prop == 'createTime') {
        if(column.order == 'descending') {
          this.sort = 1;
        } else if(column.order == 'ascending') {
          this.sort = 2;
        }
      } else if(column.prop == 'reportUserUid') {
        if(column.order == 'descending') {
          this.sort = 3;
        } else if(column.order == 'ascending') {
          this.sort = 4;
        }
      }
      this.getPage();
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
      this.userIdArr = sels.map(item => item.userId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(!this.dynamicId && !this.dynamicIdChecked) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请输入评论序号',
          type: 'warning'
        })
        return false
      }
      if(!this.zoneId && !this.zoneIdChecked) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请输入动态序号',
          type: 'warning'
        })
        return false
      }
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sort'] = this.sort;
      param['state'] = this.state;
      param['reportState'] = this.reportState;
      param['showState'] = this.showState;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['reportStartTime'] = this.reportStartTime;
      param['reportEndTime'] = this.reportEndTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      // param['abduceState'] = this.abduceState;
      param['sex'] = this.sex;
      param['type'] = this.type;
      // param['machineAuditState'] = this.machineAuditState;
      // param['isDel'] = this.isDel;
      param['dynamicId'] = this.dynamicIdChecked?0:this.dynamicId;
      param['zoneId'] = this.zoneIdChecked?0:this.zoneId;
      param['limitState'] = this.limitState?1:0;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getZoneInteractPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }
      //更新用户日志
      if(column.label == '发表人日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      if(column.label == '作者日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.zoneAuthorResumeInfo.userId
          },
          close: () => {
            row['zoneAuthorResumeInfo']['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

    },

    batchUpdate(state, showState) {
      if(this.idArray.length > 0) {
        let _this = this
        this.$confirm('确定批量【'+ (state == 1?'通过':state == 2?'不通过': '') + (showState == 0?'-展示':'-隐藏') + '】选中的互动？').then(() => {
          this.batchLoading = true
          let param = {}
          param['idArr'] = this.idArray;
          param['state'] = state;
          param['showState'] = showState;
          postFormData(updateZoneInteractState, param).then((data) => {
            let {msg, code } = data;
            if (code == 200) {
              this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              })
              for(let j=0;j<_this.idArray.length;j++){
                for(let i=0;i<_this.pageDataList.length;i++) {
                  if(_this.pageDataList[i]['id'] == _this.idArray[j]) {
                    _this.pageDataList.splice(i,1);
                    i--;
                  }
                }
              }
              if(_this.pageDataList.length == 0){
                _this.getPage();
              }
            } else {
              this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              })
            }
            this.batchLoading = false;
          })
        })
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一条记录进行操作',
          type: 'warning'
        })
      }
    },


    batchRejectUpdate() {
      if (this.idArray.length > 0) {
        let _this = this
        Dialog.open({
          title: '确认批量不通过选中的用户？',
          component: BatchRejectDialog,
          data: {
            idArray: _this.idArray,
            userIdArr: _this.userIdArr,
            width: '500px'
          },
          confirm: (result) => {
            for(let j=0;j<_this.idArray.length;j++){
              for(let i=0;i<_this.pageDataList.length;i++) {
                if(_this.pageDataList[i]['id'] == _this.idArray[j]) {
                  _this.pageDataList.splice(i,1);
                  i--;
                }
              }
            }
            if(_this.pageDataList.length == 0){
              _this.getPage();
            }else {
              _this.$refs.multipleTableRef.clearSelection();
            }
          }
        })
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一位用户进行操作',
          type: 'warning'
        })
      }
    },

    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList
      })
    },

  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>
.playBtn {
  color: #c0c4cc;
  cursor: pointer;
}
.playBtn:hover {
  color: #409eff;
}
.imgItem {
  position: relative;
}
.closeBtn {
  width: 2em;
  height: 2em;
  background-color: rgba(0,0,0,0.8);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0.6em;
}
</style>
